/*
 *
 * Home constants
 *
 */

export const GET_USER_MANDU_WATCHER =
  "app/Administrator/Users/Home/GET_USER_MANDU_WATCHER"
export const GET_USER_MANDU_FAILED =
  "app/Administrator/Users/Home/GET_USER_MANDU_FAILED"
export const GET_USER_MANDU_SUCCESS =
  "app/Administrator/Users/Home/GET_USER_MANDU_SUCCESS"

export const GET_USER_CREATE_MANDU_WATCHER =
  "app/Administrator/Users/Home/GET_USER_CREATE_MANDU_WATCHER"
export const GET_USER_CREATE_MANDU_FAILED =
  "app/Administrator/Users/Home/GET_USER_CREATE_MANDU_FAILED"
export const GET_USER_CREATE_MANDU_SUCCESS =
  "app/Administrator/Users/Home/GET_USER_CREATE_MANDU_SUCCESS"

export const DELETE_COMPANY_USER_ACCESS_MANDU_WATCHER =
  "app/Administrator/Users/Home/DELETE_COMPANY_USER_ACCESS_MANDU_WATCHER"
export const DELETE_COMPANY_USER_ACCESS_MANDU_FAILED =
  "app/Administrator/Users/Home/DELETE_COMPANY_USER_ACCESS_MANDU_FAILED"
export const DELETE_COMPANY_USER_ACCESS_MANDU_SUCCESS =
  "app/Administrator/Users/Home/DELETE_COMPANY_USER_ACCESS_MANDU_SUCCESS"

export const SAVE_COMPANY_USER_ACCESS_MANDU_WATCHER =
  "app/Administrator/Users/Home/SAVE_COMPANY_USER_ACCESS_MANDU_WATCHER"
export const SAVE_COMPANY_USER_ACCESS_MANDU_FAILED =
  "app/Administrator/Users/Home/SAVE_COMPANY_USER_ACCESS_MANDU_FAILED"
export const SAVE_COMPANY_USER_ACCESS_MANDU_SUCCESS =
  "app/Administrator/Users/Home/SAVE_COMPANY_USER_ACCESS_MANDU_SUCCESS"

export const RECOVERY_PASSWORD_WATCHER =
  "app/Administrator/Users/Home/RECOVERY_PASSWORD_WATCHER"
export const RECOVERY_PASSWORD_SUCCESS =
  "app/Administrator/Users/Home/RECOVERY_PASSWORD_SUCCESS"
export const RECOVERY_PASSWORD_FAILED =
  "app/Administrator/Users/Home/RECOVERY_PASSWORD_FAILED"

export const USER_DELETE_WATCHER =
  "app/Administrator/Users/Home/USER_DELETE_WATCHER"
export const USER_DELETE_SUCCESS =
  "app/Administrator/Users/Home/USER_DELETE_SUCCESS"
export const USER_DELETE_FAILED =
  "app/Administrator/Users/Home/USER_DELETE_FAILED"

export const USER_SAVE_WATCHER =
  "app/Administrator/Users/Home/USER_SAVE_WATCHER"
export const USER_SAVE_SUCCESS =
  "app/Administrator/Users/Home/USER_SAVE_SUCCESS"
export const USER_SAVE_FAILED = "app/Administrator/Users/Home/USER_SAVE_FAILED"

export const DELETE_USER_WATCHER =
  "app/Administrator/Users/Home/DELETE_USER_WATCHER"
export const DELETE_USER_SUCCESS =
  "app/Administrator/Users/Home/DELETE_USER_SUCCESS"
export const DELETE_USER_FAILED =
  "app/Administrator/Users/Home/DELETE_USER_FAILED"

export const GET_OPTIONS_WATCHER =
  "app/Administrator/Users/Home/GET_OPTIONS_WATCHER"
export const GET_OPTIONS_SUCCESS =
  "app/Administrator/Users/Home/GET_OPTIONS_SUCCESS"

export const USER_CHANGE_ROLE_WATCHER =
  "app/Administrator/Users/Home/USER_CHANGE_ROLE_WATCHER"
